
import React, { useState, useEffect } from 'react';
const Projects = () => {
    let [allProjects, setAllProjects] = useState(null);
    let [currentProject, setCurrentProject] = useState([]);
    const [error, setError] = useState(null);
    const [navButtonClicked, setNavButtonClicked] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const response = await fetch(`https://kumardesai.com/ajax-project-sections.php`);
                //const response = await fetch(`http://localhost:10046/ajax-project-sections.php`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                let projects = getSectionNavTitles(result);

                setAllProjects(projects);
                projects[0].status = 'active'; //set first project as active
                setCurrentProject(projects[0]); //default project
            } catch (err) {
                setError(err);
            }
        })();
        
    }, []);
    
    // next buttons title
    function getSectionNavTitles(projects) {
        projects.forEach((proj, i)=>{
            proj.sections = proj.sections && proj.sections.map((section, ii) => {
                if (proj.sections[ii+1]?.title) {
                    return {...section, next: proj.sections[ii+1]?.title};
                } else {
                    return {...section, next: 'Return to Home'};
                }
            });
            projects[i].sections = proj.sections;
        })
        return projects;
    }
    
    //update project nav and set active
    if (navButtonClicked) {
        let projectIndex = allProjects.findIndex((item) => (item.slug === navButtonClicked.target.id));
        let projects = allProjects.map((project, i) => ((i === projectIndex) ? {...project, status: 'active'} : {...project, status: ''} ));

        setNavButtonClicked(false);
        setAllProjects(projects);
        setCurrentProject(projects[projectIndex]);
    }

    const selectNextSlide = ({ target }) => {
        let id = target.parentElement.id;
        let index = 0;
        let currentIndex = currentProject.sections.findIndex(item => item.id === id);
        let nextIndex = (currentIndex + 1) % currentProject.sections.length; // Wraps to 0 if at end
        let prevIndex = (currentIndex - 1 + currentProject.sections.length) % currentProject.sections.length; // Wraps to end if at start

        if (target.classList.contains('panel-image')) {
            index = currentIndex;
        } else if (target.classList.contains('next')) {
            index = nextIndex;
        } else if (target.classList.contains('previous')) {
            index = prevIndex;
        }

        currentProject.sections = currentProject.sections && currentProject.sections.map((item, i) => (index == i) ? {...item, status: 'active'} : {...item, status: ''});
        let updatedProject = {...currentProject, sections: currentProject.sections};
        setCurrentProject(updatedProject);
    }

    return (
        <div className="container-xl component projects">
            <ul className="projects-nav" onClick={setNavButtonClicked}>
                {allProjects && allProjects.map((item, i)=>(<li className={`slide ${item.status}`} id={item.slug} key={i}>{item.title}</li>))}
            </ul>
            <div className="slider-container" onClick={selectNextSlide}>
                {
                    currentProject.sections && currentProject.sections.map((item, index) => (

                        <div className={`slide ${(item.status) ? item.status : ''}`} id={item.id} key={index} >

                            <h3 className="top-title">{item.title}</h3>
                            
                            <div className="textarea">
                                {index===0 ? (<h1>{currentProject.title} <span href={currentProject.url}>{currentProject.url.replace(/^https?:\/\//, '')}</span></h1>) : ('') }

                                {(item.description && item.description.length === 1) && (
                                    <p>{item.description[0].li}</p>
                                )}
                                
                                {(item.description && item.description.length > 1) && (
                                    <ul className="list">{item.description.map((desc, i) => (<li key={i}>{desc.li}</li>))}</ul>
                                )}
                                
                                {(item.technologies && item.technologies.length > 1) && (
                                    <ul className="technologies">{item.technologies.map((logo, i) => (<li key={i}><img src={logo.image} /><p>{logo.name}</p></li>))}</ul>
                                )}
                            </div>
                            
                            <img src={`${item.background_image}`}  className="panel-image" />
                            
                            {index!==0 ? (<a className="previous">&larr; Back</a>) : ('') }
                            
                            {index+1 == currentProject.length ? (<a className="next">&larr; {item.next}</a>) : (<a className="next">{item.next} &rarr;</a>) }
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default Projects;